export default __webpack_public_path__ + "static/media/Chalkduster.b292d679.ttf";